
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import {
  NoteCreateInterface,
  ProfileMapInterface,
} from '@/services/QC-V2/chat/interfaces';
import { NoteRepositoryInterface } from '@/services/QC-V2/note/interfaces';
import { TicketInterface } from '@/services/QC-V2/ticket/interfaces';
import DeleteNoteDialog from '@/components/dialogs/qc-v2/note/DeleteNoteDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class TicketHBNotes extends Vue {
  @Prop() private ticket!: TicketInterface;
  @Prop({ default: true }) private initiallyCollapsed: boolean;

  private collapsed: boolean = true;

  private noteRepositoryV2!: NoteRepositoryInterface;

  private loading: boolean = true;

  private async created(): Promise<void> {
    this.collapsed = this.initiallyCollapsed;
    this.loading = false;
  }

  @Watch('ticket')
  private async reloadData(): Promise<void> {
    this.loading = true;
    this.loading = false;
  }
}
